// @flow
import { getCreator, postCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  SET_TRACKING_SESSION: `${environment.apiUrl}/tracking/session`,
  GET_SESSION: `${environment.apiUrl}/auth/session`,
  SET_CUSTOM_SESSION: `/auth/set-session`,
  LOGOUT_CUSTOM_SESSION: `/auth/remove-session`,
  INDEX_CUSTOM_SESSION: `/auth/index-session`,
  REFRESH_SESSION: `${environment.apiUrl}/auth/session/refresh`,
  LOGIN: `${environment.apiUrl}/auth/login`,
  FB_LOGIN: `${environment.apiUrl}/auth/facebook`,
  LOGOUT: `${environment.apiUrl}/auth/logout`,
  REGISTER: `${environment.apiUrl}/auth/signup`,
  RECOVER: `${environment.apiUrl}/auth/recovery`,
  VERIFY: `${environment.apiUrl}/auth/verify`,
});

export const setTrackingSessionApi = postCreator(fetch, endpoints.SET_TRACKING_SESSION);
export const setCustomSessionApi = postCreator(fetch, endpoints.SET_CUSTOM_SESSION);
export const logoutCustomSessionApi = postCreator(fetch, endpoints.LOGOUT_CUSTOM_SESSION);
export const indexCustomSessionApi = postCreator(fetch, endpoints.INDEX_CUSTOM_SESSION);
export const refreshSessionApi = getCreator(fetch, endpoints.REFRESH_SESSION);
export const getSessionApi = getCreator(fetch, endpoints.GET_SESSION);
export const loginApi = postCreator(fetch, endpoints.LOGIN);
export const loginFbApi = postCreator(fetch, endpoints.FB_LOGIN);
export const logoutApi = postCreator(fetch, endpoints.LOGOUT);
export const registerApi = postCreator(fetch, endpoints.REGISTER);
export const recoverApi = postCreator(fetch, endpoints.RECOVER);
export const verifyApi = postCreator(fetch, endpoints.VERIFY);



// WEBPACK FOOTER //
// ./src/modules/auth/api.js